import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import users from './modules/users'
import charts from './modules/charts'

import products from './modules/products'
import categories from './modules/categories'

import machines from './modules/machines'
import lockers from './modules/Lockers'
import coils from './modules/coils'
import shelves from './modules/shelves'
import modulos from './modules/modulos'
import stock from './modules/stock'
import boxes from './modules/boxes'
import combos from './modules/combos'
import movements from './modules/movements'
import sync from './modules/sync'
import requests from './modules/requests'
import vmPrice from './modules/vm-price'
import sazonal from './modules/Sazonal'

import sales from './modules/sales'
import vouchers from './modules/vouchers'
import customers from './modules/customers'

import general from './modules/general'
import company from './modules/company'
import flag from './modules/flag'
import visual from './modules/visual'
import parent from './modules/parent'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    users,
    charts,

    products,
    categories,

    machines,
    lockers,
    coils,
    shelves,
    modulos,
    stock,
    boxes,
    combos,
    movements,
    vmPrice,
    sync,
    requests,
    sazonal,

    sales,
    vouchers,
    customers,

    general,
    company,
    flag,
    visual,
    parent
  },
})